import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';

const SENTRY_DSN =
    'https://a4f3b79d8e95f11ed16fa2bc94f69c9d@o4510209831927808.ingest.us.sentry.io/4510209859715072';

export function initSentry(): void {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
    const release = process.env.VITE_SENTRY_RELEASE || 'development';

    // Determine environment based on backend URL
    let environment = 'development';
    if (backendUrl.includes('api.fire-knife.com')) {
        environment = 'production';
    } else if (backendUrl.includes('api-staging.fire-knife.com')) {
        environment = 'staging';
    }

    // Don't initialize Sentry in development mode
    if (environment === 'development') {
        console.info('[Sentry] Skipping initialization in development mode');
        return;
    }

    if (!SENTRY_DSN) {
        console.warn('[Sentry] No DSN provided, skipping initialization');
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        environment,
        release,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
        // Session Replay
        replaysSessionSampleRate: 0.1, // Sample 10% of sessions
        replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
    });
}
